export default {"src":"/_next/static/media/boom_64.022c4019.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};